// extracted by mini-css-extract-plugin
export default {"table":"styles_table__HmFYk","fullView":"styles_fullView__gU3Gp","shimmer":"styles_shimmer__kt9xK"};